import apiClient from "../config/api";

const oeeFlowchartService = {
    getAll: async () => {
        const response = await apiClient.get("/oeeflowchart");
        return response.data;
    },

    getById: async (id) => {
        const response = await apiClient.get(`/oeeflowchart/${id}`);
        return response.data;
    },

    create: async (data) => {
        const response = await apiClient.post("/oeeflowchart", data);
        return response.data;
    },

    update: async (id, data) => {
        const response = await apiClient.post(`/oeeflowchart/update/${id}`, data);
        return response.data;
    },

    delete: async (id) => {
        const response = await apiClient.post(`/oeeflowchart/delete/${id}`);
        return response.data;
    }
};

export default oeeFlowchartService;
